import CheckBox from 'components/ui-components/CheckBox';

const ContactOptions = ({ contactOptions, setContactOptions }) => {
  const {
    marketing_opt_in: marketingOptIn,
    direct_mail_communication: directMailCommunication,
    email_communication: emailCommunication,
    sms_communication: smsCommunication,
    phone_communication: phoneCommunication,
  } = contactOptions;

  const contactOps = [
    {
      id: 'contactPost',
      value: directMailCommunication !== '0',
      onChange: () =>
        setContactOptions(curState => ({
          ...curState,
          marketing_opt_in: '0',
          direct_mail_communication:
            curState.direct_mail_communication === '0' ? '1' : '0',
        })),
      label: 'Post',
    },
    {
      id: 'textContact',
      value: smsCommunication !== '0',
      onChange: () =>
        setContactOptions(curState => ({
          ...curState,
          marketing_opt_in: '0',
          sms_communication: curState.sms_communication === '0' ? '1' : '0',
        })),
      label: 'Text/Chat',
    },
    {
      id: 'emailContact',
      value: emailCommunication !== '0',
      onChange: () =>
        setContactOptions(curState => ({
          ...curState,
          marketing_opt_in: '0',
          email_communication: curState.email_communication === '0' ? '1' : '0',
        })),
      label: 'Email',
    },
    {
      id: 'phoneContact',
      value: phoneCommunication !== '0',
      onChange: () =>
        setContactOptions(curState => ({
          ...curState,
          marketing_opt_in: '0',
          phone_communication: curState.phone_communication === '0' ? '1' : '0',
        })),
      label: 'Telephone',
    },
    {
      id: 'noContact',
      value: marketingOptIn !== '0',
      onChange: () =>
        setContactOptions(() => ({
          direct_mail_communication: '0',
          sms_communication: '0',
          email_communication: '0',
          phone_communication: '0',
          marketing_opt_in: '1',
        })),
      label:
        'I do not want to receive exclusive offers, special promotions or marketing from CEF',
      className: 'summary-contact__no-contact',
    },
  ];

  return (
    <div className="summary-contact__box fl fl-col jc-sb pl-16 pr-16 pt-20 pb-18 mb-26 fw-400">
      <p>
        From time to time we’d love to be able to update you about CEF’s
        products and services, exclusive offers and promotions, newsletters and
        market research.
      </p>
      <p className="fw-600 mb-0">
        Please select how you would like us to contact you:
      </p>
      <div className="grid grid-cols-2 m-grid-cols-3 mb-18">
        {contactOps.map(({ id, value, onChange, label, className }) => (
          <CheckBox
            key={id}
            id={id}
            value={value}
            onChange={onChange}
            label={label}
            className={`fl mt-14 mb-3 ${className || ''}`}
            labelClass="fw-400"
          />
        ))}
      </div>
      <p>
        If you would like further information on how we process your data please
        see our{' '}
        <a
          href="https://www.cef.co.uk/info/privacy_policy"
          target="_blank"
          rel="noreferrer">
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default ContactOptions;
